import React from 'react';

const AWS_DMS = () => {
  return (
    <div>
      <h1>AWS_DMS</h1>
      <p>This is the AWS_DMS component.</p>
    </div>
  );
};

export default AWS_DMS;
